import {
    YoUser,
    YoUserProjectTool,
    YoUserProjectToolGe,
    YoUserProjectToolsMap
} from '@yakoffice/yakoffice-firebase';
import { IUser } from '../../model/user';
import { IProject } from '../../model/project';
import { ITool } from '../../model/tool';

export const MapToUserModel = (user: YoUser) => {
    return {
        email: user.email,
        isAdmin: user.isAdmin,
        iamRoles: user.iamRoles,
        projects: user.projects?.map(project => {
            return {
                projectId: project.projectId,
                tools: project.tools?.map(userProjectTool => {
                    return {
                        toolId: userProjectTool.toolId,
                        toolProjectId: userProjectTool.toolProjectId,
                        projectRoles: userProjectTool.projectRoles || [],
                        gameEnvironments: userProjectTool.gameEnvironments?.map(ge => {
                            return {
                                toolGeId: ge.toolGeId,
                                roles: ge.roles || []
                            };
                        }) || []
                    };
                }) || []
            };
        }) || []
    };
};

export const MapToDto = (user: IUser, projects: IProject[], tools: ITool[]): YoUser => {
    return {
        email: user.email,
        isAdmin: user.isAdmin,
        iamRoles: user.iamRoles,
        projects:
            user
                .projects
                // Filter out projects that don't exist
                .filter(userProject => projects.some(project => project.id === userProject.projectId))
                // Filter out projects that don't have any tools
                .filter(userProject => userProject.tools.length > 0)
                .map((userProject): YoUserProjectToolsMap => {

                    const project = projects.find(project => project.id === userProject.projectId);

                    return {
                        projectId: userProject.projectId,
                        tools: userProject
                            .tools
                            // Filter out projects without any tools enabled
                            .filter(userTool => project?.tools.find(projectTool => projectTool.toolId === userTool.toolId))
                            .map((userTool): YoUserProjectTool => {
                                return {
                                    toolId: userTool.toolId,
                                    toolProjectId: userTool.toolProjectId,
                                    projectRoles: userTool.projectRoles
                                        // Filter out project roles that don't exist
                                        .filter(userProjectRole => tools.find(tool => tool.id === userTool.toolId)?.projectRoles.find(projectRole => projectRole.id === userProjectRole)),
                                    gameEnvironments: userTool.gameEnvironments
                                        // Filter out game environments that don't exist
                                        .filter(userGe => project?.tools.find(projectTool => projectTool.toolId === userTool.toolId)?.gameEnvironments.find(ge => ge.toolGeId === userGe.toolGeId))
                                        // Filter out game environments that don't have any roles
                                        .filter(userGe => userGe.roles.length > 0)
                                        .map((ge): YoUserProjectToolGe => {
                                            return {
                                                toolGeId: ge.toolGeId,
                                                roles: ge.roles
                                                    // Filter out roles that don't exist  NB.  This could result in an empty list being saved
                                                    .filter(role => tools.find(tool => tool.id === userTool.toolId)?.gameEnvironmentRoles.find(geRole => geRole.id === role))
                                                    .map(s => s) || []
                                            };
                                        }) || []
                                };
                            }) || []
                    };
                }) || []
    };
};
